// React Component
import React from 'react'

// App Component
import { AppLayout, HeaderLayout } from '../../layouts'

// Features
import { CompanyCreate } from '../../features/company'

const CompanyCreateView = () => {
    return (
        <AppLayout>
            <div className='container'>
                <CompanyCreate />
            </div>
        </AppLayout>
    )
}

CompanyCreateView.displayName = "CompanyCreateView";

export default CompanyCreateView